module.exports = __webpack_public_path__ + "static/media/CAP_Logo.65cdbd3d.svg";